import './send.css'
import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';


function Send() {
     const [formData, setFormData] = useState({
        phone: ''
      });

       const [successMessage, setSuccessMessage] = useState('');
        const [errorMessage, setErrorMessage] = useState('');
      
        const handleChange = (e) => {
          const { name, value } = e.target;
          setFormData({
            ...formData,
            [name]: value
          });
        };

        const handleSubmit = (e) => {
            e.preventDefault();
            if (formData.phone.length < 10 || formData.phone.length > 13) {
              setErrorMessage('يجب أن يحتوي رقم الجوال على بين 10 و 13 رقماً.');
              setSuccessMessage('');
              return;
            }
        
            const formUrl = 'https://formspree.io/f/mkggpznz'; // استبدل 'your-form-id' بالمعرف الخاص بك على Formspree
        
            axios.post(formUrl, formData)
              .then(response => {
                console.log('Form submitted successfully:', response);
                setSuccessMessage('تم إرسال الرقم بنجاح.');
                setErrorMessage('');
                setFormData({ phone: ''}); // إعادة تعيين الحقول بعد الإرسال الناجح
              })
              .catch(error => {
                console.error('Error submitting form:', error);
                setErrorMessage('حدث خطأ أثناء إرسال الرقم. حاول مرة أخرى.');
                setSuccessMessage('');
              });
          };

          useEffect(() => {
              if (successMessage) {
                const timer = setTimeout(() => {
                  setSuccessMessage('');
                }, 5000);
                return () => clearTimeout(timer);
              }
            }, [successMessage]);
          
            useEffect(() => {
              if (errorMessage) {
                const timer = setTimeout(() => {
                  setErrorMessage('');
                }, 5000);
                return () => clearTimeout(timer);
              }
            }, [errorMessage]);


  return (
    <div className='send' id='sendid'>
            <div className='color-overlay'></div>
            <div className="container">
            <div className="row">
                <div className='col-12'>
                <h2 className='callh2 mb-2'>انضم الآن إلى خدمة الواتساب الخاصة بنا</h2>
                <p className='pcall mt-0 w-90'>واستمتع بالبقاء على اطلاع دائم بكل ما هو جديد ومميز.</p>
                <form className='formsend' onSubmit={handleSubmit}>
                <input type="number" name="phone" value={formData.phone} onChange={handleChange} required  class="form-control" placeholder="إكتب رقم جولك....ثم إضغط إرسال" />
                <button type="submit">
                <FontAwesomeIcon icon={faPaperPlane} className='sendicon'/>
                </button>
                {successMessage && <div className="notification success">{successMessage}</div>}
                {errorMessage && <div className="notification error">{errorMessage}</div>}
                </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Send
